import React, { useState } from 'react'
import EmployerNavbar from '../../../../components/Profile-navbar/employer-navbar'
import { recommendedJobs } from '../../../../data'
import { Link } from 'react-router-dom'
import { viewedPosts } from '../../../../data'
import { interviewJobs } from '../../../../data'
import { Container, Row, Col, Button, Card } from 'react-bootstrap'
import './feedback.css'

const Feedback = () => {
    const [selectedButton, setSelectedButton] = useState(0);

  const handleButtonClick = (buttonIndex) => {
    setSelectedButton(buttonIndex);
  };
  return (

    <div>
      <EmployerNavbar/>
      <Container fluid className='p-1 p-md-5 '>
        <h1 className='mt-3 p-3 jobs-header'>My Post Feedbacks</h1>
        <div className='d-block d-md-none mt-4'>
        <div className='d-flex gap-sm-5'>
        <button className={selectedButton === 0 ? 'active jobs-button' : 'jobs-button'} onClick={() => handleButtonClick(0)}>
            My Posts
            </button>
            <button className={selectedButton === 1 ? 'active jobs-button' : 'jobs-button'} onClick={() => handleButtonClick(1)}>
            Viewed
            </button>
            <button className={selectedButton === 2 ? 'active jobs-button' : 'jobs-button'} onClick={() => handleButtonClick(2)}>Applied
            </button>
           
        </div>
        <div className='d-flex gap-sm-5 mt-3'>
        
            <button className={selectedButton === 3 ? 'active jobs-button' : 'jobs-button'} onClick={() => handleButtonClick(3)}>Scheduled Interviews
            </button>
        </div>

        </div>
        <div className='d-md-flex d-none gap-lg-5 gap-md-3 mt-5 align-items-center justify-content-center'>
        <button className={selectedButton === 0 ? 'active jobs-button' : 'jobs-button'} onClick={() => handleButtonClick(0)}>
            My Posts
            </button>
            <button className={selectedButton === 1 ? 'active jobs-button' : 'jobs-button'} onClick={() => handleButtonClick(1)}>
            Viewed
            </button>
            <button className={selectedButton === 2 ? 'active jobs-button' : 'jobs-button'} onClick={() => handleButtonClick(2)}>Applied
            </button>
            <button className={selectedButton === 3 ? 'active jobs-button' : 'jobs-button'} onClick={() => handleButtonClick(3)}>Scheduled Interviews
            </button>
        </div>
        <div className='py-5 px-2'>
        {selectedButton === 0 && (
              <Row className="py-4 px-2">
                {recommendedJobs.map((jobs) => {
                   const {id,
                    image,
                    role,
                    company,
                    amount,
                    frequency,
                    period,
                    workMode,
                    icon,
                    } = jobs;
                    return(
                        <Col lg={4} md={6} xs={12} className='mb-3'>
                        <Card className='p-3 border-0' style={{background: '#F5F8FD', height:'100%'}} >
                        <div style={{flex:1}}>
                        <div className='d-flex gap-3'>
                            <img src={image} style={{width: '53px',height: '53px'}}/>
                            <div className='d-flex align-items-center gap-5'>
                              <button className='period-btn'>{period}</button>
                              <p className='remote'> <img src={icon}/>{workMode}</p>
                            </div>
                        </div>
                        <div className='d-flex flex-column  recommend-details mt-2'>
                        <h4>{role}</h4>
                            <p>{company}</p>
                            <h6>{amount}&nbsp;<span>({frequency})</span></h6>
                        </div>
                        </div>
                        <div className='d-flex align-items-center justify-content-center  mt-4'>
                        <button className='apply-btn'>Apply</button>
                           
                        </div>
                        
                        </Card>
                        
                        </Col>
                    )
                  
                    
                })}
              
              </Row>
        )}
        
        {selectedButton === 1 && (
              <div className="py-4 px-2 ">
                {viewedPosts.map((viewed) => {
                const {id,name,jobFunction,postViewed,dateViewed} = viewed;
                  return(
                    <Card className='applied-card p-3 mb-3 border-0'>
                    <Row className='align-items-center gap-0'>
                      <Col  xs={12} sm={1}className='d-flex align-items-center justify-content-center text-center'>
                      <button className='id-btn'>{id}</button>
                      </Col>
                      <Col className='d-flex flex-column applied-info '>
                      <h5>{name}</h5>
                               <h4>{jobFunction}</h4>
                               <p>{postViewed}</p>
                               <p>Viewed {dateViewed}</p>
                      
                      </Col>
                      <Col xs={12} sm={3}  className='d-flex align-items-center justify-content-center text-center mt-3 mt-sm-0'>
                      <Link to='/employerprofile' className='
                        text-decoration-none ' >
                        <button className='
                        text-decoration-none view-btn'>
                        View Profile
                          </button></Link>
                      </Col>
                    </Row>
  
                  </Card>
                  )
                })}
              </div>
        )}
         {selectedButton === 2 && (
              <div className="py-4 px-2 ">
                {viewedPosts.map((viewed) => {
               const {id,name,jobFunction,postViewed,dateViewed,location} = viewed;
                  return(
                    <Card className='applied-card p-3 mb-3 border-0'>
                    <Row className='align-items-center gap-0'>
                      <Col  xs={12} sm={1}className='d-flex align-items-center justify-content-center text-center'>
                      <button className='id-btn'>{id}</button>
                      </Col>
                      <Col className='d-flex flex-column  employer-applied'>
                      <h4>Applicant Details: <span>{name}, <i><b>{jobFunction}</b></i></span></h4>
                              <h4>Location: <span>{location}</span></h4>
                              <p><b>Applied for:</b> {postViewed}</p>
                              <p>Applied {dateViewed}</p>
                      
                      </Col>
                      <Col xs={12} sm={3}  className='d-flex align-items-center justify-content-center text-center mt-3 mt-sm-0'>
                      <Link to='/employerprofile' className='
                        text-decoration-none ' >
                        <button className='
                        text-decoration-none view-btn'>
                        View CV
                          </button></Link>
                      </Col>
                    </Row>
  
                  </Card>
                  )
                })}
              </div>
        )}
        {selectedButton === 3 && (
              <Row className="py-4 px-2">
               {
                interviewJobs.map((interview) => {
                  const {id,
                    image,
                    role,
                    company,
                    amount,
                    frequency,
                    period,
                    workMode,
                    icon,
                    date,
                    time,
                    venue} = interview;
                    return(
                     <Col xs={12} lg={6} className='mb-3'>
                      
                        <Card className=' p-3 border-0' style={{background: '#F5F8FD', height:'100%'}}>
                            <Row style={{flex: 1}}>
                              
                              <Col xl={2} lg={12} md={2} xs={12}className='pb-3'>
                              <img className='companyImg' src={image}/>
                              </Col>
                              <Col xl={5} lg={6} md={5} sm={6} xs={12}className='d-flex flex-column gap-2 role-details ms-xl-2 '>
                              
                              <h2>{role}</h2>
                              <h4>{company}</h4>
                              <p>{amount} &nbsp; <span>({frequency})</span></p>
                              <div className='d-flex gap-xl-4 gap-lg-2 gap-md-4 gap-4 align-items-center'>
                                <button className='period-btn'>{period}</button>
                            
                                <p> <img src={icon}/> &nbsp;{workMode}</p>
                             </div>
                            
                              
                              </Col>
                              <Col xl={4} lg={6} md={5} sm={6} xs={12}className='d-flex flex-column  interview-details mt-2 mt-sm-0'>
                              <h3>Interview Details</h3>
                          <p>Date: &nbsp; <span>
                          {date}</span></p>
                          <p>Time: &nbsp; <span>
                          {time}</span></p>
                          <p>Venue: &nbsp; <span>
                          {venue}</span></p>
                              </Col>
                          </Row>
                          <div className='d-flex align-items-center justify-content-center'>
                          <button className='chat-btn'>Chat with Job Seeker</button>
                          </div>
                        </Card>
                     </Col>
                    )
                  }
                )
               }
              </Row>
          )}
        </div>

      </Container>
    
    </div>
  )
}

export default Feedback
